import React, { useEffect, useState } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';

import { useTranslations } from '../../../contexts/LocalizationContext';

const MotionBox = motion(Box);

type ProgressProps = {
  show: boolean;
  onAnimationComplete: () => void;
  duration?: number;
  showCountdown?: boolean;
  resetKey?: string | number;
};
export const TimedProgress = ({
  show,
  onAnimationComplete,
  duration = 5,
  showCountdown = false,
  resetKey,
}: ProgressProps) => {
  const translations = useTranslations();
  const [seconds, setSeconds] = useState(duration);

  useEffect(() => {
    if (!show) return;

    setSeconds(duration);

    const interval = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [show, duration]);

  return (
    <>
      <Box pt={8} w="100%">
        <Box w="100%" h="10px" bg="grey.200" borderRadius="md" overflow="hidden">
          <MotionBox
            key={resetKey}
            h="100%"
            bg="orange.500"
            initial={{ width: '100%' }}
            animate={{ width: '0%' }}
            transition={{ duration, ease: 'linear' }}
            onAnimationComplete={onAnimationComplete}
          />
        </Box>
      </Box>
      {showCountdown ? (
        <Text fontSize={14} p={1}>
          {translations('progress_bar_time_info', {
            '{{seconds}}': seconds.toString(),
          })}
        </Text>
      ) : null}
    </>
  );
};
